// Pointer-lock intent and native acknowledgement are deliberately separate.
// Tab may close a menu while the preceding asynchronous release is in flight.
export function createPointerSession({canvas,doc=document,isActive=()=>true,onLost=()=>{},onError=()=>{},onChange=()=>{}}){
 let wanted=false,pending=false,releasing=false,expectedRelease=false,disposed=false,attempt=0;
 const locked=()=>doc.pointerLockElement===canvas;
 function fail(error){if(disposed||(!wanted&&!pending)||locked())return;wanted=false;pending=false;onError(error);onChange();}
 function reconcile(){
  if(disposed)return;
  if(!wanted||!isActive()){
   if(locked()&&!releasing){expectedRelease=true;releasing=true;doc.exitPointerLock();}
   return;
  }
  if(locked()||pending||releasing)return;
  pending=true;const id=++attempt;
  try{
   if(!canvas.requestPointerLock)throw new Error('Pointer lock unavailable');
   const result=canvas.requestPointerLock();
   result?.then(()=>{if(disposed){if(locked())doc.exitPointerLock();return;}if(id===attempt){pending=false;reconcile();}},error=>{if(id===attempt)fail(error);});
  }catch(error){fail(error);}
 }
 function changed(){
  if(disposed)return;
  pending=false;
  if(!locked()){
   const expected=expectedRelease||releasing;expectedRelease=false;releasing=false;
   if(!expected&&wanted){wanted=false;if(isActive())onLost();}
  }
  reconcile();onChange();
 }
 const failed=()=>fail(new Error('Pointer lock denied by browser'));
 doc.addEventListener('pointerlockchange',changed);doc.addEventListener('pointerlockerror',failed);
 return {setWanted(value){wanted=Boolean(value);reconcile();},get locked(){return locked();},get pending(){return pending;},get releasing(){return releasing;},get wanted(){return wanted;},read(){return{locked:locked(),wanted,pending,releasing};},dispose(){wanted=false;if(locked())doc.exitPointerLock();disposed=true;doc.removeEventListener('pointerlockchange',changed);doc.removeEventListener('pointerlockerror',failed);}};
}
